var exports = {
  "Qs": "ThemeAcceptModal.module__content___Vm4xdD",
  "h_": "ThemeAcceptModal.module__description___Vm4xdD",
  "Hy": "ThemeAcceptModal.module__codeContainer___Vm4xdD",
  "AS": "ThemeAcceptModal.module__pre___Vm4xdD",
  "Y4": "ThemeAcceptModal.module__hljs___Vm4xdD",
  "lB": "ThemeAcceptModal.module__codeActions___Vm4xdD",
  "vo": "ThemeAcceptModal.module__codeActionsVisible___Vm4xdD",
  "cL": "ThemeAcceptModal.module__copyButton___Vm4xdD",
  "nJ": "ThemeAcceptModal.module__copyIcon___Vm4xdD",
  "KQ": "ThemeAcceptModal.module__loadingText___Vm4xdD",
  "kc": "ThemeAcceptModal.module__errorText___Vm4xdD",
  "qr": "ThemeAcceptModal.module__footer___Vm4xdD",
  "Dm": "ThemeAcceptModal.module__trustSites___Vm4xdD",
};

module.exports = exports;
